'use client';
import dynamic from 'next/dynamic';
import { useCallback, useEffect, useRef, useState } from 'react';
import { YMM_OPEN_EVENT } from '@/packages/sxm/ymm/ymmModalEvent';

const YmmModalPortal = dynamic(() => import('./YmmModalPortal'), { ssr: false });

export function YmmModalHost(): React.JSX.Element | null {
    const [hasOpened, setHasOpened] = useState(false);

    const isReady = useRef(false);

    const openModal = useCallback(() => {
        setHasOpened(true);
        if (isReady.current) {
            document.documentElement.classList.add('showYmm');
        }
    }, []);

    const onModalReady = useCallback(() => {
        isReady.current = true;
        document.documentElement.classList.add('showYmm');
    }, []);

    useEffect(() => {
        window.addEventListener(YMM_OPEN_EVENT, openModal);
        return () => window.removeEventListener(YMM_OPEN_EVENT, openModal);
    }, [openModal]);

    useEffect(() => {
        if (new URLSearchParams(window.location.search).get('ymm') === 'true') {
            const timer = window.setTimeout(openModal, 0);
            return () => window.clearTimeout(timer);
        }
    }, [openModal]);

    if (!hasOpened) {
        return null;
    }

    return <YmmModalPortal onReady={onModalReady} />;
}
